import { ProcessJobType } from '@/graphql/graphql';

/** Optional steps of a run — mirror of the server's `NON_FATAL_CHILD_TYPES`
 *  (`analysisRuns.query.ts`): a failed chained PDF or per-surface render does
 *  not fail the analysis, so the details drawer labels it "optional" and the
 *  progress toast never fails a run on one. Its own module (no registry
 *  import), so the progress hooks can share it without pulling the launcher in. */
export const NON_FATAL_STEP_TYPES: readonly ProcessJobType[] = [ProcessJobType.PdfReport, ProcessJobType.Render];

export const isOptionalStepType = (type: ProcessJobType | string): boolean =>
  (NON_FATAL_STEP_TYPES as readonly string[]).includes(type);
